//import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
//then in your template {{ myproperty.cretedDate | formatToLongDate }}

import Vue from 'vue';
import * as formatMethods from '@SharedServices/formatting.service';

Vue.filter('formatDateTimeToDate', formatMethods.formatDateTimeToDate);
Vue.filter('formatToLongDate', formatMethods.formatToLongDate);
Vue.filter('formatToLongDateWithNoDaySuffix', formatMethods.formatToLongDateWithNoDaySuffix);
Vue.filter('formatToMediumShortDate', formatMethods.formatToMediumShortDate);
Vue.filter('formatToMediumShortDateWithComma', formatMethods.formatToMediumShortDateWithComma);
Vue.filter('formatToShortDate', formatMethods.formatToShortDate);
Vue.filter('formatToLongDateWithYear', formatMethods.formatToLongDateWithYear);
Vue.filter('formatToLongDateLocalTimeWithNoYear', formatMethods.formatToLongDateLocalTimeWithNoYear);
Vue.filter('formatTime', formatMethods.formatTime);
Vue.filter('formatTimeAddEST', formatMethods.formatTimeAddEST);
Vue.filter('formatToShortDateWithComma', formatMethods.formatToShortDateWithComma);
Vue.filter('formatTimeWithOutAmPm', formatMethods.formatTimeWithOutAmPm);
Vue.filter('formatTimeWithJustAmPm', formatMethods.formatTimeWithJustAmPm);
Vue.filter('formatUsPhoneNumberWithAreaCode', formatMethods.formatUsPhoneNumberWithAreaCode);
Vue.filter('toYesNo', formatMethods.ToYesNo);
Vue.filter('toNumberWithCommas', formatMethods.formatNumberWithCommas);
Vue.filter('toNumberTo2Decimals', formatMethods.formatNumberTo2Decimals);
Vue.filter('formatToMonthAbbr', formatMethods.formatToMonthAbbr);
Vue.filter('formatToDayNumber', formatMethods.formatToDayNumber);
Vue.filter('formatToDayOfWeekAbbr', formatMethods.formatToDayOfWeekAbbr);
Vue.filter('formatToYearNumber', formatMethods.formatToYearNumber);
Vue.filter('formatNumberToUsMoney', formatMethods.formatNumberToUsMoney);
Vue.filter('formatDateTimeSecToDate', formatMethods.formatDateTimeSecToDate);
Vue.filter('formatDateTimeSecToDateAsIs', formatMethods.formatDateTimeSecToDateAsIs);
Vue.filter('formatBytes', formatMethods.formatBytes);
Vue.filter('bytesToSize', formatMethods.bytesToSize);
Vue.filter('currency', function (value) {
    if (isNaN(value)) {
        value = 0;
    }
    return '$' + parseFloat(value).toFixed(2);
});